document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('notif_achat');

  if (!popup) {
    console.error('Popup element not found.');
    return;
  }

  // Récupérer le type de page
  const pageType = popup.getAttribute('data-page-type');
  // console.log(`Page Type: '${pageType}'`);

  // Récupérer les réglages de pages activées depuis les attributs data
  const showOnIndex = popup.getAttribute('data-index-page').trim() === 'true';
  const showOnProduct = popup.getAttribute('data-product-page').trim() === 'true';
  const showOnCollection = popup.getAttribute('data-collection-page').trim() === 'true';
  const showOnArticle = popup.getAttribute('data-article-page').trim() === 'true';
  const showOnBlog = popup.getAttribute('data-blog-page').trim() === 'true';
  const showOnCart = popup.getAttribute('data-cart-page').trim() === 'true';
  const showOnOther = popup.getAttribute('data-other-page').trim() === 'true';

  // console.log(`Show on Index: ${showOnIndex}`);
  // console.log(`Show on Product: ${showOnProduct}`);
  // console.log(`Show on Collection: ${showOnCollection}`);
  // console.log(`Show on Article: ${showOnArticle}`);
  // console.log(`Show on Blog: ${showOnBlog}`);
  // console.log(`Show on Cart: ${showOnCart}`);
  // console.log(`Show on Other: ${showOnOther}`);

  const shouldShowPopup =
    (pageType === 'index' && showOnIndex) ||
    (pageType === 'product' && showOnProduct) ||
    (pageType === 'collection' && showOnCollection) ||
    (pageType === 'article' && showOnArticle) ||
    (pageType === 'blog' && showOnBlog) ||
    (pageType === 'cart' && showOnCart) ||
    (pageType === 'other' && showOnOther);

  // console.log(`Should Show Popup: ${shouldShowPopup}`);

  if (!shouldShowPopup) {
    // console.log('Popup will not be shown on this page.');
    return; // Ne pas afficher la popup si elle n'est pas activée sur cette page
  }

  const closeButton = document.getElementById('close_popup');
  // if (!closeButton) {
  //   console.error('Close button not found.');
  // }

  const timeLoop = parseFloat(popup.getAttribute('data-time-loop')) * 1000;
  const timeStay = parseFloat(popup.getAttribute('data-time-stay')) * 1000;

  const names = popup
    .getAttribute('data-names')
    .split(' | ')
    .map((item) => item.trim());
  const cities = popup
    .getAttribute('data-cities')
    .split(' | ')
    .map((item) => item.trim());
  const hours = popup
    .getAttribute('data-hours')
    .split(' | ')
    .map((item) => item.trim());

  // console.log(`Names: ${names}`);
  // console.log(`Cities: ${cities}`);
  // console.log(`Hours: ${hours}`);

  const productDataScript = document.getElementById('product-data');
  if (!productDataScript) {
    console.error('Product data script not found.');
    return;
  }
  const productData = JSON.parse(productDataScript.textContent);
  const products = productData.products;

  if (!products.length) {
    console.error('No products found.');
    return;
  }

  let startTime = null;
  let isPopupVisible = false;
  let isPopupDisabled = false;

  let lastSelectedName = null;
  let lastSelectedCity = null;
  let lastSelectedHour = null;
  let lastSelectedProduct = null;

  // Fonction pour décoder les entités HTML
  function decodeHtmlEntities(str) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = str;
    return textArea.value;
  }

  function getRandomItem(array, lastSelected) {
    if (array.length < 2) {
      return array[0];
    }

    let randomItem;
    do {
      randomItem = array[Math.floor(Math.random() * array.length)];
    } while (randomItem === lastSelected);
    return randomItem;
  }

  function updateRandomContent() {
    const nameElement = popup.querySelector('.random-names');
    const cityElement = popup.querySelector('.random-cities');
    const productLinkElements = popup.querySelectorAll('.random-products-link');
    const productTitleElement = popup.querySelector('.random-products-title');
    const productImageElement = popup.querySelector('.random-products-image');
    const hourElement = popup.querySelector('.random-hours');

    const randomName = getRandomItem(names, lastSelectedName);
    const randomCity = getRandomItem(cities, lastSelectedCity);
    const randomHour = getRandomItem(hours, lastSelectedHour);
    const randomProduct = getRandomItem(products, lastSelectedProduct);

    lastSelectedName = randomName;
    lastSelectedCity = randomCity;
    lastSelectedHour = randomHour;
    lastSelectedProduct = randomProduct;

    if (nameElement) nameElement.textContent = randomName;
    if (cityElement) cityElement.textContent = randomCity;
    if (hourElement) hourElement.textContent = randomHour;

    if (productLinkElements.length) {
      productLinkElements.forEach((linkElement) => {
        linkElement.href = randomProduct.url;
      });
    }

    if (productTitleElement) {
      productTitleElement.textContent = decodeHtmlEntities(randomProduct.title); // Décodage ici
      productTitleElement.href = randomProduct.url;
    }

    if (productImageElement) {
      productImageElement.src = randomProduct.image;
      productImageElement.alt = decodeHtmlEntities(randomProduct.title); // Décodage ici aussi pour l'attribut alt
    }
  }

  function showPopup(timestamp) {
    if (isPopupDisabled || !shouldShowPopup) {
      // console.log('Popup disabled or should not be shown.');
      return;
    }

    if (!startTime) startTime = timestamp;
    const elapsedTime = timestamp - startTime;

    if (isPopupVisible) {
      if (elapsedTime >= timeStay) {
        // console.log('Hiding popup');
        popup.classList.remove('active');
        isPopupVisible = false;
        startTime = timestamp;
      }
    } else {
      if (elapsedTime >= timeLoop) {
        updateRandomContent();
        // console.log('Showing popup');
        popup.classList.add('active');
        isPopupVisible = true;
        startTime = timestamp;
      }
    }

    requestAnimationFrame(showPopup);
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      isPopupDisabled = true;
      popup.classList.remove('active');
    });
  }

  requestAnimationFrame(showPopup);
});
